"use client"
import { useEffect, useRef, useState } from "react";
import AvatarImage from "./AvatarImage";

function ActorSelectionDropdown({ thisUser, callback, parentComponent, parentPost }) {
  const [open, setOpen] = useState(false);
  const [actingAs, setActingAs] = useState(thisUser);
  const ref = useRef(null);

//   console.log("PARENTPOST", parentPost)
// console.log("ACTINGAS", actingAs)
  // Close on outside click
  useEffect(() => {

    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className="relative inline-block">
      {/* Trigger | REPLY AS */}
      <button

        onClick={() => {thisUser?.user_affiliations_organizations_owned &&  setOpen((v) => !v)}}
        className="flex items-center justify-center h-9 px-3 rounded-full text-xs text-slate-500 hover:text-teal-400 transition"
      >
        <div className="flex items-center text-sm gap-2">
          {actingAs.user_uuid 
          ? 
          <><div><AvatarImage module={'USER'} data={actingAs} size={'xxs'}/></div>
          <div>{thisUser.user_first_name} {thisUser.user_last_name}</div></> 
          : 
          <><div><AvatarImage module={'ORGANIZATION'} data={actingAs} size={'xxs'}/></div>
          <div>{actingAs?.organization_name}</div></> 
          }
          </div> 
        
      </button>

      {/* Dropdown */}
      {open && (
        <div className="relative">
        <div className={`absolute left-0 ${parentComponent === 'THREAD' ? 'mb-2' // had bottom-full
           : 'mt-2'} w-48 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg shadow-lg z-[100]`}>
          
          {/* User */}
          {/* <div className="px-3 py-2 text-xs text-slate-400">
            Personal
          </div> */}

          {/* ROOT ONLY */}
          {/* {thisUser.user_roles.role === 'ROOT' && 
          <div>
            <span className="text-xs mx-4">ROOT</span>
            <button 
           onClick={()=>{callback({actor:parentPost.user_data, type:'personal'}); setOpen(false); setActingAs(thisUser)}}
          className="w-full text-left px-3 py-2 text-sm hover:bg-slate-100 dark:hover:bg-slate-700 flex items-center gap-2">
             <div><AvatarImage module={'USER'} data={parentPost.user_data} size={'xxs'}/></div><div>{parentPost.user_data.user_first_name} {parentPost.user_data.user_last_name}</div>
          </button>
          <hr/>
          </div>
          } */}


          <button 
           onClick={()=>{callback({type:'personal'}); setOpen(false); setActingAs(thisUser)}}
          className="w-full text-left px-3 py-2 text-sm hover:bg-slate-100 dark:hover:bg-slate-700 flex items-center gap-2">
             <div><AvatarImage module={'USER'} data={thisUser} size={'xxs'}/></div><div>{thisUser.user_first_name} {thisUser.user_last_name}</div>
          </button>

          {/* Orgs */}
          {thisUser.user_affiliations_organizations_owned?.length > 0 && (
            <>
              {/* <div className="px-3 py-2 text-xs text-slate-400">
                Organizations
              </div> */}

              {thisUser.user_affiliations_organizations_owned.map((org) => (
                <button
                onClick={()=>{callback({actor: org, type:'organization'}); setOpen(false); setActingAs(org)}}
                  key={org.organization_uuid}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-slate-100 dark:hover:bg-slate-700 flex items-center gap-2"
                >
                  <div><AvatarImage module={'ORGANIZATION'} data={org} size={'xxs'}/></div><div>{org?.organization_name}</div>
                </button>
              ))}
            </>
          )}
        </div>
        </div>
      )}
    </div>
  );
}

export default ActorSelectionDropdown